/**
 * This module provides functionality to block specific services/features for users from restricted countries.
 */
(function ($) {
	'use strict';

	// Create a namespace for country blocking functionality
	window.VeriffGeo = window.VeriffGeo || {};

	// Restricted countries and regions list
	VeriffGeo.blockedCountries = [
		'IR', // Iran
		'KP', // North Korea
		'SY', // Syria
		'RU', // Russia
		'BY', // Belarus
		'VE', // Venezuela
		'CU', // Cuba
		'AF', // Afghanistan
		'CN', // China
		'HK', // Hong Kong
		'MO'  // Macau
	];

	// Ukraine regions that are blocked - if we can't block by region, we'll block all Ukraine
	VeriffGeo.blockedRegions = {
		'UA': ['Crimea', 'Donetsk', 'Luhansk'] // Ukraine regions to block
	};

	// Store user's location data
	VeriffGeo.userCountry = '';
	VeriffGeo.userRegion = '';
	VeriffGeo.isBlocked = false;
	VeriffGeo.isLocationDetected = false;

	/**
	 * Check if a user should be blocked based on their location
	 * @returns {boolean} True if user should be blocked, false otherwise
	 */
	VeriffGeo.isUserBlocked = function () {
		if (VeriffGeo.blockedCountries.includes(VeriffGeo.userCountry)) {
			return true;
		}

		return !!(VeriffGeo.userCountry === 'UA' && VeriffGeo.blockedRegions['UA']);
	};

	/**
	 * Handle visibility of menu items based on the user's country
	 * - Show Privacy Choices only for users in Mexico (MX) and the United States (US)
	 * - Hide Cookie Policy for users in Mexico (MX) and the United States (US)
	 */
	VeriffGeo.handlePrivacyChoicesVisibility = function () {
		// List of countries where Privacy Choices should be visible and Cookie Policy hidden
		var specialCountries = ['US', 'MX'];

		// Check if a user's country is in the special countries list
		var isInSpecialCountry = specialCountries.includes(VeriffGeo.userCountry);

		// Hide the Privacy Choices menu item if not in special countries
		if (!isInSpecialCountry) {
			$('.privacy-choices-option').css('display', 'none');
		}

		// Hide the Cookie Policy menu item if in special countries
		if (isInSpecialCountry) {
			$('.cookie-policy-option').css('display', 'none');
		}
	};

	/**
	 * Detect user's country using ipapi.co (free geolocation API)
	 * @param {Function} callback - Function to run after detection (optional)
	 */
	VeriffGeo.detectUserCountry = function (callback) {
		// Using ipapi.co - free tier allows up to 1,000 requests per day
		$.ajax({
			url: 'https://ipapi.co/json/',
			type: 'GET',
			dataType: 'json',
			success: function (response) {
				if (response && response.country) {
					VeriffGeo.userCountry = response.country; // ISO country code

					// If it's Ukraine, store region information if available
					if (response.country === 'UA' && response.region) {
						VeriffGeo.userRegion = response.region;
					}
					VeriffGeo.isBlocked = VeriffGeo.isUserBlocked();
				}

				VeriffGeo.isLocationDetected = true;

				// Run callback if provided
				if (typeof callback === 'function') {
					callback(VeriffGeo.isBlocked);
				}

				// Trigger an event that other scripts can listen to
				$(document).trigger('veriff:countryDetected', [VeriffGeo.userCountry, VeriffGeo.isBlocked]);
			},
			error: function () {
				// Fallback - if API call fails
				console.log('Geolocation API failed, proceeding without country blocking');
				VeriffGeo.isLocationDetected = true;

				// Run callback if provided
				if (typeof callback === 'function') {
					callback(false);
				}

				// Trigger event with failure status
				$(document).trigger('veriff:countryDetectionFailed');
			}
		});
	};

	/**
	 * Initialize the country blocking functionality
	 * @param {Object} options - Configuration options
	 */
	VeriffGeo.init = function (options) {
		const settings = $.extend({
			detectOnLoad: true,
			alertElementId: 'country-block-alert',
			restrictedSelectors: []
		}, options);

		// Store settings for later use
		VeriffGeo.settings = settings;

		// Detect country immediately if specified
		if (settings.detectOnLoad) {
			VeriffGeo.detectUserCountry();
		}

		return this;
	};

	$(document).ready(function () {
		VeriffGeo.init();
	});

	// Add event listener for when country detection is complete
	$(document).on('veriff:countryDetected', function () {
		VeriffGeo.handlePrivacyChoicesVisibility();
	});
})(jQuery);